<div class="signatory-list-wrapper">
  <app-toolbar />
  <section class="feature-shell">
    <div class="page-header">
      <p class="page-description">
        Access comprehensive signatory information with options to search, consult, and download the
        up-to-date list.
      </p>
      <app-az-button
        data-testid="bcr-120-download-button"
        [label]="'Download Signatory List'"
        [icon]="'download'"
        [iconPosition]="'left'"
        [disabled]="isDownloading()"
        (click)="onDownload()"
      />
    </div>

    <app-az-searchbar
      data-testid="bcr-120-search-bar"
      [search]="true"
      [datePicker]="false"
      [value]="searchText()"
      [placeholder]="'Search by Company Name, Address or Company Registration Number'"
      (valueChange)="onSearchChange($event)"
    />

    <div
      *ngIf="loading()"
      class="loading-overlay"
      aria-live="polite"
      aria-label="Loading signatory list"
    >
      <app-spinner [display]="true" [diameter]="48" aria-label="Loading" />
    </div>

    <div *ngIf="loadError()" class="error-state" role="alert">
      {{ loadError() }}
    </div>

    <app-az-table
      data-testid="bcr-120-signatory-table"
      *ngIf="!loading() && !loadError()"
      [data]="displayRows()"
      [columns]="columns"
      [emptyMessage]="'No signatories found'"
    />
  </section>
  <app-footer />

  <app-status-change-modal
    [isOpen]="isDownloading()"
    [initialState]="'processing'"
    [title]="'Downloading'"
    [processingResultTitle]="'Preparing your PDF…'"
  />
</div>
